import {
  Box,
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  Typography,
  makeStyles,
} from "@material-ui/core";
import { useRef, useState } from "react";

import AdjustDialog from "../pages/customer-insight/members/AdjustDialog";
import DialogCloseButton from "./DialogCloseButton";
import { ReceiptWrapper } from "../pages/payment/payment-success/ReceiptDialog";
import VoidDialog from "../pages/customer-insight/members/VoidDialog";
import { useTranslate } from "react-admin";

const useStyles = makeStyles((theme) => ({
  paper: {
    margin: "0px auto",
    width: 668,
    maxWidth: 1500,
    // height: 1200,
    borderRadius: "10px",
  },
  dialogContainer: {
    margin: "0 auto",
  },
  addressGrid: {
    width: "402px",
    display: "grid",
    margin: "0 auto",
    gridTemplateColumns: "50% auto",
    gridAutoRows: "auto",
    gap: 5,
  },
  title: {
    color: theme.orange,
    fontSize: 30,
    fontWeight: "bold",
    margin: "10px auto 0",
    display: "table",
  },
  productText: { fontSize: 12, fontWeight: 600 },
  productCode: { fontSize: 8 },
  productGrid: {
    width: 402,
    maxHeight: 200,
    display: "grid",
    margin: "0 auto",
    gridTemplateColumns: "200px auto 100px",
    gridAutoRows: "auto",
    gap: 5,
    overflowY: "auto",
  },
  summaryGrid: {
    width: "402px",
    display: "grid",
    margin: "0 auto",
    gridTemplateColumns: "50% auto",
    gridAutoRows: "auto",
    gap: 7,
  },
  gridLeft: {
    justifySelf: "start",
  },
  gridCenter: {
    justifySelf: "center",
  },
  gridRight: {
    justifySelf: "end",
  },
  container: {
    display: "flex",
    justifyContent: "space-between",
    margin: "auto 50px",
  },
  // note: {
  //   margin: "5px 80px 5px 80px",
  //   opacity: "50%",
  // },
  textBottom: {
    fontStyle: "normal",
    fontSize: 12,
    fontWeight: 600,
    lineHeight: 1,
  },
  addressText: {
    fontStyle: "normal",
    fontSize: 12,
    lineHeight: 1,
  },
  totalText: {
    fontStyle: "normal",
    fontWeight: 800,
    fontSize: 20,
    color: theme.blue,
  },
  note: {
    width: 402,
    margin: "0 auto 15px",
  },
  button: {
    fontSize: 30,
    fontWeight: "bold",
    //backgroundColor: theme.darkGray,
    color: theme.white,
    borderRadius: "0 0",
  },
  redButton: {
    backgroundColor: theme.red,
    "&:hover": {
      backgroundColor: theme.red,
    },
  },
  buttonContainer: {
    display: "grid",
    padding: 0,
    boxSizing: "border-box",
    gridTemplateColumns: "50% 50%",
  },
}));

const CIReceiptDialog = ({
  transaction,
  onClose,
  onClick,
  open,
  showCommand,
}) => {
  const classes = useStyles();
  const translate = useTranslate();
  const [showAdjustDialog, setShowAdjustDialog] = useState(false);
  const [showVoidDialog, setShowVoidDialog] = useState(false);
  const myRef = useRef();

  if (!transaction)
    return (
      <Dialog
        onClose={onClose}
        open={open}
        classes={{ root: classes.dialogContainer, paper: classes.paper }}
      >
        <Typography>Loading</Typography>
      </Dialog>
    );

  const { bill_detail } = transaction;

  return (
    <Dialog
      onClose={onClose}
      open={open}
      classes={{ root: classes.dialogContainer, paper: classes.paper }}
    >
      <DialogTitle></DialogTitle>
      <DialogCloseButton onClose={onClose} />
      <DialogContent>
        {
          <ReceiptWrapper
            ref={myRef}
            isCI={true}
            receipt={{
              id: transaction.transaction_no,
              date: transaction.create_local_time,
            }}
            payment={{
              paymentChannels: transaction.payment_channels,
              member: transaction.member,
            }}
            paymentTransaction={{
              items: bill_detail,
              deliveryCost: transaction.delivery_cost,
              tier_name: "",
              branchId: transaction.branch_id,
              staffId: transaction.create_by_id,
              summary: {
                total_discount: transaction.total_discount,
                total_payment: transaction.total_payment,
                total_revenue: transaction.total_revenue,
                earn_amount:
                  Object.values(transaction.earn).reduce(
                    (total, cur) => total + cur,
                    0
                  ) ?? 0,
              },
            }}
          />
        }
      </DialogContent>
      {transaction.remark && (
        <Typography align="left" className={classes.note}>{`${translate(
          "ra.text.note"
        )}: ${transaction.remark}`}</Typography>
      )}

      {showCommand ? (
        <Box className={classes.buttonContainer}>
          <Button
            disabled={transaction.status === "Void"}
            className={[classes.button, classes.redButton]}
            onClick={() => setShowVoidDialog(true)}
            color="secondary"
            variant="contained"
          >
            Void
          </Button>
          <Button
            disabled={transaction.status === "Void"}
            className={[classes.button]}
            onClick={() => setShowAdjustDialog(true)}
            variant="contained"
          >
            Adjust
          </Button>
        </Box>
      ) : (
        <Button
          className={classes.button}
          autoFocus
          onClick={onClick}
          color="primary"
          variant="contained"
        >
          Done
        </Button>
      )}
      <AdjustDialog
        open={showAdjustDialog}
        transactionNo={transaction.transaction_no}
        existingPoint={transaction.earn?.reward ?? 0}
        onClose={() => setShowAdjustDialog(false)}
        memberId={transaction.member.id}
        version={transaction.__v}
      />
      <VoidDialog
        open={showVoidDialog}
        onClose={() => setShowVoidDialog(false)}
        transactionNo={transaction.transaction_no}
        memberId={transaction.member.id}
        version={transaction.__v}
      />
    </Dialog>
  );
};

export default CIReceiptDialog;
